import { AfterViewInit, ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CELL_TYPE, CtDatatableActionCustomConfiguration, CtDatatableConfiguration, CTDatatablePaginationParameter, CTGeneralService, CtSearchFiltersComponent, CtSearchFiltersConfiguration, DeleteConfirmService } from '@ctsolution/ct-framework';
import { TableColumn } from '@swimlane/ngx-datatable';
import { AddressBookListFilters, AddressBookListParameter } from 'src/app/core/classes/address-book-list.parameter';
import { AddressBookParameter } from 'src/app/core/classes/address-book.parameter';
import { AddressBookController } from 'src/app/core/controllers/address-book.controller';
import { AddressBookResponse, AddressBookTypeEnum, AddressBookTypeLabelMapping } from 'src/app/core/interfaces/address-book-response';
import { JwtService } from 'src/app/core/lib/jwt.service';
import { ListService } from 'src/app/core/lib/list.service';
import { AddressBookService } from './address-book.service';

@Component({
  selector: 'app-address-book',
  templateUrl: './address-book.component.html',
  styleUrls: ['./address-book.component.scss']
})
export class AddressBookComponent implements AfterViewInit {

  @ViewChild("searchFilter") public searchFilter?: CtSearchFiltersComponent;
  @ViewChild("typeCellTemplate") public typeCellTemplate!: TemplateRef<any>;
  @ViewChild("detailAddressBookButton") public detailAddressBookButton!: TemplateRef<any>;

  addressBook!: CtDatatableConfiguration;
  filtersConfiguration: CtSearchFiltersConfiguration = CtSearchFiltersConfiguration
    .create()
    .setFilters(AddressBookListFilters);

  private params: AddressBookListParameter = AddressBookListParameter.create();

  viewModel: {
    addressBookList: Array<AddressBookResponse>;
  } = { addressBookList: [] };

  constructor(
    private cdr: ChangeDetectorRef,
    private addressBookController: AddressBookController,
    private listService: ListService,
    private deleteConfirm: DeleteConfirmService,
    private general: CTGeneralService,
    private router: Router,
    private jwt: JwtService,
    private addressBookService: AddressBookService
  ) { }

  async ngOnInit(): Promise<void> {

    const addressBookEnabled = await this.jwt.getAddressBookEnabled()

    if (addressBookEnabled == false) {

      this.router.navigate(['/dashboard'])

    }

  }


  ngAfterViewInit() {

    this.setup();

  }

  private async setup() {

    this.viewModel.addressBookList = await this.getData();
    await this.setTable();

  }

  private async setTable() {

    const columns: TableColumn[] = [
      { prop: "Name", name: "Nome", sortable: false, minWidth: 400 },
      { prop: "UpdateAt", name: "Ultima modifica", sortable: false, cellClass: CELL_TYPE.DATE },
      {
        prop: "Shared", name: "Condivisa",
        cellClass: CELL_TYPE.BOOLEAN,
        sortable: false
      },
      // { prop: "Description", name: "Descrizione", sortable: false },
      { prop: "Type", name: "Tipo", sortable: false, cellTemplate: this.typeCellTemplate },
      {
        prop: "Enabled", name: "Abilitata",
        cellClass: CELL_TYPE.BOOLEAN,
        sortable: false
      },
    ];

    this.addressBook = CtDatatableConfiguration
      .create()
      .setScrollbarH(true)
      .setRowHeight(65)
      .setColumns(columns)
      .setController("AddressBook")
      .setCount(this.viewModel.addressBookList.length)
      .setEditingActionEnabled(true)
      .setDeleteActionEnabled(true)
      .setCustomDatatableActionConfiguration(
        CtDatatableActionCustomConfiguration
          .create()
          .setTemplateOutlet(this.detailAddressBookButton));

    this.cdr.detectChanges();

  }

  private getData() {

    return new Promise<Array<AddressBookResponse>>((resolve, reject) => {

      this.addressBookController
        .addressBookList()
        .subscribe({
          next: (response: any) => {

            //Qua poi da modificare con la responseList
            const result = response.Result ?? [];
            resolve(result);

          },
          error: (err) => {

            this.addressBook.setLoadingIndicator(false);
            reject(err);

          }
        });

    });

  }

  filter(event: any) {

    this.params = event ?? {};

    this.fetch();

  }

  fetch(pagination?: CTDatatablePaginationParameter) {

    this.addressBook.setLoadingIndicator(true);

    const paginatedData = this.listService.getFilteredDataAddressBook<AddressBookResponse>(this.viewModel.addressBookList, this.params, pagination);

    setTimeout(() => {

      this.addressBook
        .setRows(paginatedData)
        .setLoadingIndicator(false);

    }, 350);

  }

  async delete(addressBook: AddressBookParameter) {

    if (!addressBook.Oid) return;

    this.deleteConfirm
      .open()
      .afterClosed()
      .subscribe((result?: boolean) => {

        if (result) {

          this.addressBookController
            .delete(AddressBookParameter.create().setOid(addressBook.Oid))
            .subscribe(() => {

              this
                .general
                .reloadCurrentRoute();

            });

        }

      });


  }

  create() {


    this.addressBookService.edit().afterClosed()
      .subscribe(async () => {

        this.viewModel.addressBookList = await this.getData();
        this.fetch()

      });

  }

  detail(addressBook: AddressBookParameter) {

    this.router.navigate(["/", "amministrazione", "rubrica", "gestione-rubriche"], { queryParams: { Oid: addressBook.Oid } });

  }

  edit(addressBook: AddressBookParameter) {

    this.addressBookService.edit(addressBook).afterClosed()
      .subscribe(async () => {

        this.viewModel.addressBookList = await this.getData();
        this.fetch()

      });

  }

  ngOnDestroy() {

    this.searchFilter?.reset();

  }


  getTypeLabel(row: AddressBookTypeEnum | null): string {

    if (row === null || !(row in this.AddressBookTypeLabelMapping)) {
      return '';
    }

    return this.AddressBookTypeLabelMapping[row];
  }

  protected readonly AddressBookTypeLabelMapping = AddressBookTypeLabelMapping;

}
